import React, { FC } from 'react'
import styles from './Toggle.module.scss'
import classNames from 'classnames'

type ToggleCustomStyles = {
  width?: string
  height?: string
  radius?: string
  spacing?: string
}

type ToggleProps = {
  isDisabled?: boolean
  onToggle?: () => void
  value: boolean
  customStyles?: ToggleCustomStyles
}

const Toggle: FC<ToggleProps> = (props) => {
  const { isDisabled, onToggle, value, customStyles = {} } = props
  const { width, height, radius, spacing } = customStyles
  const customCssVars = {
    ...(width && { '--toggle-width': width }),
    ...(height && { '--toggle-height': height }),
    ...(radius && { '--toggle-radius': radius }),
    ...(spacing && { '--toggle-spacing': spacing }),
  } as React.CSSProperties

  const onToggleIfEnabled = () => {
    if (isDisabled) {
      return
    }
    onToggle?.()
  }

  return (
    <div
      onClick={onToggleIfEnabled}
      tabIndex={0}
      className={classNames(styles.toggleWrapper, {
        [styles.toggleWrapperOn]: value,
        [styles.toggleWrapperDisabled]: isDisabled,
      })}
      style={customCssVars}
    >
      <div className={styles.toggleSlider} />
    </div>
  )
}

export default Toggle
